export const ASSET_CUSTOM_THUMBNAIL_BASE_EVENT = `asset:custom:thumbnail`;

export enum AssetCustomThumbnailEvent {
	INIT = `${ASSET_CUSTOM_THUMBNAIL_BASE_EVENT}:init`,
	INITIALIZED = `${ASSET_CUSTOM_THUMBNAIL_BASE_EVENT}:initialized`,
	EXTEND = `${ASSET_CUSTOM_THUMBNAIL_BASE_EVENT}:extend`,

	UPLOAD = `${ASSET_CUSTOM_THUMBNAIL_BASE_EVENT}:upload`,
}
